import React from 'react';

export default class TableAdd extends React.Component{

    render(){
        return(<div>Table Page</div>);
    }
}